import { ADD_FAV_ITEM, REMOVE_FAV_ITEM, SET_FAV_ITEMS } from "../actions/types";

const initialState = {
  items: [],
  itemsIds: {},
};

const favReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FAV_ITEMS: {
      let ids = action.data.reduce((acc, { item_id, _id }) => {
        acc[item_id] = {
          item_id: item_id,
          _id,
        };
        return acc;
      }, {});
      return {
        ...state,
        items: action.data,
        itemsIds: ids,
      };
    }
    case ADD_FAV_ITEM: {
      return {
        ...state,
        items: [action.data, ...state.items],
        itemsIds: {
          ...state.itemsIds,
          [action.data.item_id]: {
            item_id: action.data.item_id,
            _id: action.data._id,
          },
        },
      };
    }
    case REMOVE_FAV_ITEM: {
      let filteredItems = state.items.filter(
        ({ _id }) => _id !== action.data._id
      );
      let filteredItemsIds = { ...state.itemsIds };
      delete filteredItemsIds[action.data.item_id];
      return {
        ...state,
        items: filteredItems,
        itemsIds: filteredItemsIds,
      };
    }
    default:
      return state;
  }
};

export default favReducer;
